import Vue from 'vue'
import App from './App.vue'
import "./style/global.less"
import router from "./router";
import moment from "moment";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import i18n from "./lang"
Vue.use(ElementUI);

Vue.config.productionTip = false;


new Vue({
    render: h => h(App),
    i18n,
    router
}).$mount('#app');
Vue.filter('moment', function (value, formatString, nullMsg) {
    formatString = formatString || 'YYYY/MM/DD  HH:mm:ss';
    nullMsg = nullMsg || "--";
    if (value) {
        return moment(value).format(formatString);
    } else {
        return nullMsg
    }

})
